module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"sections":{"careers":{"heading":" Karriere bei Uns","chip":"Karriere","buttons":{"contactUs":"Kontaktieren Sie uns"}},"contact":{"heading":"Kontaktieren Sie uns","chip":"Kontakt"}}}}')
  delete Component.options._Ctor
}
